export default __webpack_public_path__ + "static/media/liviu-damian.46bd1bf2.png";